import React,{useState} from 'react';
import Wrp from '../../../hoc/Wrp/Wrp';
import SplitViewSideBarToggle from '../../../Components/SplitViewSideBarToggle';

const SearchForecast = (props) => {
	const [monthRecord,setMonthRecord] = useState(['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC']);
  const [querterlyRecord,setQuerterlyRecord] = useState(['Q1','Q2','Q3','Q4']);
	const curState = props.curState;
	const territoryList = curState.territoryList;
	const forecast_searchform = curState.forecast_searchform;
  const forecastSettingsData = curState.forecastSettings;
  const targetPeriod = forecastSettingsData ? forecastSettingsData.target_period : 0;
	const hasTerritory = forecastSettingsData ? forecastSettingsData.has_territory_enabled : false;
  const roleList = curState.roleList;
  // console.log(roleList,hasTerritory)
	const currentYear = (new Date()).getFullYear();
	let yearsList = [];
	for(let i=currentYear-8;i<=currentYear+5;i++) {
		yearsList.push(i)
	}
	const recurse = (arrVal) => {
    // console.log(arrVal)
    	return (
			arrVal.map((arr,i) => {
				return (
					<Wrp key={i}>
					{ <option value={arr.id}>{arr.territory_name}</option> }
					{arr.child_territories.length > 0 ? recurse(arr.child_territories) : null}
					</Wrp>
				)
			})
    	)
    }

  const rolesRecurse = (arrVal) => {
    // console.log(arrVal)
      return (
      arrVal.map((arr,i) => {
        return (
          <Wrp key={i}>
          { <option value={arr.id}>{arr.role_name}</option> }
          {arr.children.length > 0 ? rolesRecurse(arr.children) : null}
          </Wrp>
        )
      })
      )
    }    
	return (
		<SplitViewSideBarToggle> 
          <div className="filter_Header p-2">
            <h6 className="mb-0"> Search Forecast </h6>
          </div>
          <div className="filter_Body  bg-white">
            <div className="row">

              <div className="col-12">
              {
                hasTerritory ? 
                  <div className="form-group">
                    <label> Choose Territory </label>
                    <select className="form-control" name="element_id" value={forecast_searchform.element_id} onChange={props.searchFormChangeHandler}>
                      {
                        territoryList ? 
                          <Wrp>
                          <option value=''>All Territory</option>
                          <option value={territoryList.id}>{territoryList.territory_name}</option>
                          {
                          territoryList.child_territories.length > 0 ?
                                        recurse(territoryList.child_territories)
                                      : null
                                    }
                                      </Wrp>
                        : null
                      }
                    </select>
                  </div>
                : 
                  <div className="form-group">
                    <label> Choose Role </label>
                    <select className="form-control" name="element_id" value={forecast_searchform.element_id} onChange={props.searchFormChangeHandler}>
                      {
                        roleList ? 
                          <Wrp>
                          <option value=''>All Role</option>
                          <option value={roleList.id}>{roleList.role_name}</option>
                          {
                          roleList.children.length > 0 ?
                              rolesRecurse(roleList.children)
                            : null
                          }
                            </Wrp>
                        : null
                      }
                    </select>
                  </div>
              }
                
              </div>

              <div className="col-12">
                <div className="form-group">
                  <label className="d-block"> Choose Month </label>

                   
                  <div className="selectgroup selectgroup-secondary selectgroup-pills">
                  {
                    targetPeriod === 0 || targetPeriod === '0' ? 
                    	monthRecord.map((arr,i) => {
                    		return (
                    			<label key={i} className="selectgroup-item">
  		                      <input type="radio" name="month" value={arr} className="selectgroup-input" checked={forecast_searchform.month === arr ? true : false} onChange={props.searchFormChangeHandler} />
  		                      <span className="selectgroup-button selectgroup-button-icon"> {arr} </span>
  		                    </label>
                    		)
                    	})
                    :
                      querterlyRecord.map((arr,i) => {
                        return (
                          <label key={i} className="selectgroup-item">
                            <input type="radio" name="month" value={arr} className="selectgroup-input" checked={forecast_searchform.month === arr ? true : false} onChange={props.searchFormChangeHandler} />
                            <span className="selectgroup-button selectgroup-button-icon"> {arr} </span>
                          </label>
                        )
                      })
                  }
                  </div>
                   
                </div>
              </div>

              <div className="col-12">
                <div className="form-group">
                  <label> Choose Year </label>
                  <select className="form-control" name="year" onChange={props.searchFormChangeHandler} value={forecast_searchform.year}>
                    {
                    	yearsList.map((arr,i) => {
                    		return <option key={i} value={arr}>{arr}</option>
                    	})
                    }
                  </select>
                </div>
              </div> 


            </div>      


          </div>
          <div className="filter_Footer">
            <div></div>
            <div>
            {
                hasTerritory ? 
                <Wrp>
                  <button onClick={e=>props.getForecast('',JSON.stringify({territory_hierarchy:territoryList}))} className="btn border-default btn-border mr-2"> Execute </button>
                  <button onClick={e=>props.getForecast('',JSON.stringify({territory_hierarchy:territoryList}))} className="btn primary_bg" > Execute All </button>
                </Wrp>
                :
                <Wrp>
                  <button onClick={e=>props.getForecast('',JSON.stringify({role_hierarchy:roleList}))} className="btn border-default btn-border mr-2"> Execute </button>
                  <button onClick={e=>props.getForecast('',JSON.stringify({role_hierarchy:roleList}))} className="btn primary_bg" > Execute All </button>
                </Wrp>
            }
              
            </div>
          </div>
        </SplitViewSideBarToggle> 
	)
}

export default SearchForecast;